import { api } from './client';
import type { AuditLogsResponse } from './admin';

export async function getTenantAuditLogs(params?: {
  page?: number;
  limit?: number;
  action?: string;
}): Promise<AuditLogsResponse> {
  const response = await api.get('/api/tenant/audit-logs', { params });
  return response.data;
}

export const tenantAuditApi = {
  getAuditLogs: getTenantAuditLogs,
};
